// Superset Configuration
// This file centralizes all Superset-related configuration

const SUPERSET_CONFIG = {
    // Base URL for Superset instance
    BASE_URL: process.env.REACT_APP_SUPERSET_BASE_URL,
    
    // Superset credentials
    CREDENTIALS: {
      username: process.env.REACT_APP_SUPERSET_USERNAME,
      password: process.env.REACT_APP_SUPERSET_PASSWORD
    },
    
    // Dashboard list path
    DASHBOARD_LIST_PATH: process.env.REACT_APP_SUPERSET_DASHBOARD_PATH || '/dashboard/list/',
    
    // Default query parameters for dashboard list
    DEFAULT_PARAMS: {
      pageIndex: '0',
      sortColumn: 'changed_on_delta_humanized',
      sortOrder: 'desc',
      viewMode: 'table'
    },
    
    // Build the complete Superset dashboard list URL
    buildDashboardListUrl: (params = {}) => {
      const baseUrl = SUPERSET_CONFIG.BASE_URL;
      const path = SUPERSET_CONFIG.DASHBOARD_LIST_PATH;
      const defaultParams = SUPERSET_CONFIG.DEFAULT_PARAMS;
      
      // Merge default params with any custom params
      const queryParams = new URLSearchParams({
        ...defaultParams,
        ...params,
        // Add timestamp to prevent caching issues
        _t: Date.now()
      });
      
      return `${baseUrl}${path}?${queryParams.toString()}`;
    },
    
    // Build URL with authentication token
    buildAuthenticatedUrl: (token, customParams = {}) => {
      const params = {
        ...customParams,
        // Add authentication token if available
        ...(token && { token })
      };
      
      return SUPERSET_CONFIG.buildDashboardListUrl(params);
    },

    // Build URL with HTTP Basic Authentication
    buildBasicAuthUrl: (username, password, customParams = {}) => {
      const baseUrl = SUPERSET_CONFIG.BASE_URL;
      const path = SUPERSET_CONFIG.DASHBOARD_LIST_PATH;
      const defaultParams = SUPERSET_CONFIG.DEFAULT_PARAMS;
      
      // Merge default params with any custom params
      const queryParams = new URLSearchParams({
        ...defaultParams,
        ...customParams,
        // Add timestamp to prevent caching issues
        _t: Date.now()
      });
      
      // Create URL with path and basic auth
      const url = new URL(path, baseUrl);
      url.search = queryParams.toString();
      
      // Add username and password to URL (produces http(s)://user:pass@host/...)
      if (username && password) {
        url.username = username;
        url.password = password;
      }
      
      return url.toString();
    },

    // Build URL with embedded credentials in query parameters (less secure)
    buildCredentialUrl: (username, password, customParams = {}) => {
      const baseUrl = SUPERSET_CONFIG.BASE_URL;
      const path = SUPERSET_CONFIG.DASHBOARD_LIST_PATH;
      const defaultParams = SUPERSET_CONFIG.DEFAULT_PARAMS;
      
      // Merge default params with any custom params
      const queryParams = new URLSearchParams({
        ...defaultParams,
        ...customParams,
        // Add credentials as query parameters (less secure)
        ...(username && { username }),
        ...(password && { password }),
        // Add timestamp to prevent caching issues
        _t: Date.now()
      });
      
      return `${baseUrl}${path}?${queryParams.toString()}`;
    }
  };
  
  export default SUPERSET_CONFIG;